import { useQuery } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../../lib/query/listQuery';
import { getCustomerSegments } from '../api/customerSegments';
import type { GetCustomerSegmentsParams } from '../types';

export function useCustomerSegments(params: GetCustomerSegmentsParams = {}) {
  return useQuery({
    queryKey: ['customer-segments', params],
    queryFn: () => getCustomerSegments(params),
    ...listQueryDefaults,
  });
}
